import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {CommissionStatusType} from "../types/commission-status.type";
import {CommissionPaymentMethodType} from "../types/commission-payment-method.type";
import {CommissionPaymentDetailsModel} from "../models/commission-payment-details.model";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";

export class CommissionsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private uploadFile, private commonsAlertsService: CommonsAlertsService, private splitService, private siteContextService) {
  }

// ******************************
// External methods
// ******************************

  addCredit(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-credit-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      controllerAs: 'vm',
      fullscreen: true,
      controller: function ($scope) {

        $scope.commission = undefined;
        $scope.description = undefined;
        $scope.date = undefined;
        $scope.isAssistant = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////

        $scope.onDateChange = (date) => {
          $scope.date = date;
        }

        $scope.submit = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                commission: $scope.commission,
                name: $scope.name,
                description: $scope.description,
                isAssistant: $scope.isAssistant,
                date: $scope.date
              });
            }
          }
        }

      }
    });
  }

  addDebt(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-debt-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      controllerAs: 'vm',
      fullscreen: true,
      controller: function ($scope) {

        $scope.commission = undefined;
        $scope.description = undefined;
        $scope.date = undefined;
        $scope.isAssistant = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////////////////

        $scope.onDateChange = (date) => {
          $scope.date = date;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                commission: $scope.commission,
                isAssistant: $scope.isAssistant,
                description: $scope.description,
                date: $scope.date
              });
            }
          }
        }

      }
    });
  }

  addFee(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-fee-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      controllerAs: 'vm',
      fullscreen: true,
      controller: function ($scope) {

        $scope.feeTypeOptions = ['Credit', 'Debt'];
        $scope.file = undefined;

        $scope.payload = {
          feeType: $scope.feeTypeOptions[0],
          amount: undefined,
          description: undefined,
          attachment: undefined,
          isAssistant: false,
          date: moment().valueOf()
        }

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////////////////

        $scope.onChangeIsAssistant = (isAssistant) => {
          $scope.payload.isAssistant = isAssistant;
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.payload.date = selectedDate;
        }

        $scope.onChangeFeeType = (feeType) => {
          $scope.feeType = feeType;
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              if ($scope.file) {
                $scope.loading = true;
                self.uploadFile($scope.file)
                  .then((response) => {
                    $scope.payload.attachment = response.data;
                    self.$mdDialog.hide($scope.payload);
                  })
                  .catch((error) => {
                    if (error) {
                      self.commonsAlertsService.somethingWentWrongError();
                      $scope.loading = false;
                    }
                  })
              } else {
                self.$mdDialog.hide($scope.payload);
              }
            }
          }
        }

      }
    });
  }

  bulkEditPrice(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-edit-price-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      controllerAs: 'vm',
      fullscreen: true,
      controller: function ($scope) {

        $scope.price = undefined;
        $scope.comment = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////////////////

        $scope.onPriceChange = (price) => {
          $scope.price = price;
        }

        $scope.onCommentChange = (comment) => {
          $scope.comment = comment;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({price: $scope.price, comment: $scope.comment});
            }
          }
        }

      }
    });
  }


  consolidateCommissions(accountId, commissions?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/consolidate-commissions-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.name = undefined;
        $scope.commissions = commissions;
        $scope.allocationNumber = undefined;
        $scope.invoiceId = undefined;
        $scope.selectedConsolidatedCommission = undefined;
        $scope.isCreateNewConsolidate = true;
        $scope.commissionsChips = _.map(commissions, (c) => {
          return {name: c.serviceId || c.id, id: c.id};
        })
        $scope.accountId = accountId;
        $scope.consolidatedCommissionStatuses = [CommissionStatusType.NotPaid];
        $scope.billingCycle = self.splitService.getCarrierBillingCycle();
        $scope.docDate = $scope.billingCycle?.from ? $scope.billingCycle.from : moment().valueOf();
        $scope.taxDate = undefined;
        // $scope.billingAccountIds = _.uniq(_.flatMap(commissions, 'billingAccountId'));

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onChangeMode = (isCreateNewConsolidate) => {
          $scope.isCreateNewConsolidate = isCreateNewConsolidate;
          $scope.selectedConsolidatedCommission = undefined;
        }

        $scope.onNameChange = (name) => {
          $scope.name = name;
        }

        $scope.onInvoiceIdChange = (invoiceId) => {
          $scope.invoiceId = invoiceId;
        }

        $scope.onAllocationNumberChange = (allocationNumber) => {
          $scope.allocationNumber = allocationNumber;
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.docDate = selectedDate;
        }

        $scope.onTaxDateChange = (selectedDate) => {
          $scope.taxDate = selectedDate;
        }

        $scope.onConsolidatedCommissionSelect = (consolidatedCommission) => {
          $scope.selectedConsolidatedCommission = consolidatedCommission;
        }

        $scope.onRemoveChip = (chip) => {

        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload: any = {
                name: $scope.name,
                allocationNumber: $scope.allocationNumber,
                docDate: $scope.docDate,
                taxDate: $scope.taxDate,
                consolidatedId: _.get($scope.selectedConsolidatedCommission, 'id'),
                add: _.map($scope.commissionsChips, 'id'),
                remove: []
              }
              if ($scope.invoiceId || $scope.allocationNumber) {
                payload.paymentDetails = {
                  invoiceId: $scope.invoiceId,
                  allocationNumber: $scope.allocationNumber
                };
              }

              self.$mdDialog.hide(payload)

            }
          }
        }


      }
    })
  }

  addCommissionsToConsolidatedOrder(accountId, billingOrdersToAdd?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/add-commissions-to-consolidated-commission-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.queryString = undefined;
        $scope.fromDate = moment().startOf('month').valueOf();
        $scope.toDate = moment().endOf('month').valueOf();
        $scope.selectedIds = [];
        $scope.accountId = accountId;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onQueryStringChange = (query) => {
          $scope.queryString = query;
        }

        $scope.onFromChange = (selectedDate) => {
          $scope.fromDate = selectedDate;
        }

        $scope.onToChange = (selectedDate) => {
          $scope.toDate = selectedDate;
        }

        $scope.onCommissionSelect = (commission) => {
          const selectedIdsCopy = angular.copy($scope.selectedIds);
          const commissionIndex = _.findIndex(selectedIdsCopy, (selectedCommissionId) => {
            return _.isEqual(selectedCommissionId, commission.id);
          });

          if (commissionIndex > -1) {
            selectedIdsCopy.splice(commissionIndex, 1);
          } else {
            selectedIdsCopy.push(commission.id);
          }

          $scope.selectedIds = selectedIdsCopy;
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.selectedIds);
        }


      }
    })
  }

  payManually(name?: string, paymentDetails?: CommissionPaymentDetailsModel, commissionPrice?: number, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/pay-manually-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.paymentMethodsOptions = Object.values(CommissionPaymentMethodType);
        $scope.name = name;
        $scope.commissionPrice = commissionPrice;
        $scope.priceMinimumThresholdForAllocationNumber = self.siteContextService.getSiteInfo().priceMinimumThresholdForAllocationNumber;
        $scope.commissionPaymentDetails = paymentDetails ? angular.copy(paymentDetails) : {
          paymentMethod: $scope.paymentMethodsOptions[0],
          paymentAdditionalInfo: undefined,
          invoiceId: undefined,
          allocationNumber: undefined,
          attachments: []
        };
        $scope.file = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onPaymentMethodChange = (paymentMethod) => {
          $scope.commissionPaymentDetails.paymentMethod = paymentMethod;
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.file) {
                $scope.loading = true;
                self.uploadFile($scope.file)
                  .then((response) => {
                    $scope.commissionPaymentDetails.attachments = [response.data];
                    self.$mdDialog.hide($scope.commissionPaymentDetails);
                  })
                  .catch((error) => {
                    if (error) {
                      self.commonsAlertsService.somethingWentWrongError();
                      $scope.loading = false;
                    }
                  })
                $scope.commissionPaymentDetails.attachments = [$scope.file];
              } else {
                self.$mdDialog.hide($scope.commissionPaymentDetails);
              }
            }
          }
        }


      }
    })
  }

  pay(paymentDetails?: CommissionPaymentDetailsModel, consolidatedCommissionName?: string, commissionPrice?: number, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/pay-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.paymentMethodsOptions = Object.values(CommissionPaymentMethodType);
        $scope.consolidatedCommissionName = consolidatedCommissionName;
        $scope.commissionPrice = commissionPrice;
        $scope.priceMinimumThresholdForAllocationNumber = self.siteContextService.getSiteInfo().priceMinimumThresholdForAllocationNumber;
        $scope.commissionPaymentDetails = paymentDetails ? angular.copy(paymentDetails) : {
          paymentMethod: $scope.paymentMethodsOptions[0],
          paymentAdditionalInfo: undefined,
          invoiceId: undefined,
          attachments: []
        };
        $scope.file = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onPaymentMethodChange = (paymentMethod) => {
          $scope.commissionPaymentDetails.paymentMethod = paymentMethod;
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onChangeConsolidatedCommissionName = (consolidatedCommissionName) => {
          $scope.consolidatedCommissionName = consolidatedCommissionName;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.file) {
                $scope.loading = true;
                self.uploadFile($scope.file)
                  .then((response) => {
                    $scope.commissionPaymentDetails.attachments = [response.data];
                    self.$mdDialog.hide({
                      commissionPaymentDetails: $scope.commissionPaymentDetails,
                      consolidatedCommissionName: $scope.consolidatedCommissionName
                    });
                  })
                  .catch((error) => {
                    if (error) {
                      self.commonsAlertsService.somethingWentWrongError();
                      $scope.loading = false;
                    }
                  })
                $scope.commissionPaymentDetails.attachments = [$scope.file];
              } else {
                self.$mdDialog.hide({
                  commissionPaymentDetails: $scope.commissionPaymentDetails,
                  consolidatedCommissionName: $scope.consolidatedCommissionName
                });
              }
            }
          }
        }


      }
    })
  }

  editConsolidateCommission(consolidatedCommission, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-consolidated-commission-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.consolidatedCommission = angular.copy(consolidatedCommission);
        $scope.commissionChips = _.map(consolidatedCommission.commissionReferences, ((c) => {
          return {name: c.serviceId || c.id, id: c.id};
        }))
        $scope.billingCycle = self.splitService.getCarrierBillingCycle();

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onInvoiceIdChange = (invoiceId) => {
          if (!$scope.consolidatedCommission.paymentDetails) {
            $scope.consolidatedCommission.paymentDetails = {};
          }
          $scope.consolidatedCommission.paymentDetails.invoiceId = invoiceId;
        }

        $scope.onAllocationNumberChange = (allocationNumber: string) => {
          if (!$scope.consolidatedCommission.paymentDetails) {
            $scope.consolidatedCommission.paymentDetails = {};
          }
          $scope.consolidatedCommission.paymentDetails.allocationNumber = allocationNumber;
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.consolidatedCommission.docDate = selectedDate;
        }

        $scope.onRemoveChip = (chip) => {

        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.consolidatedCommission)

            }
          }
        }


      }
    })
  }

  attachFile(name?: string, paymentDetails?: CommissionPaymentDetailsModel, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/attach-file-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.name = name;
        $scope.commissionPaymentDetails = paymentDetails ? angular.copy(paymentDetails) : {
          attachments: []
        };
        $scope.file = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onPaymentMethodChange = (paymentMethod) => {
          $scope.commissionPaymentDetails.paymentMethod = paymentMethod;
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onSubmit = () => {
          if ($scope.file) {
            $scope.loading = true;
            self.uploadFile($scope.file)
              .then((response) => {
                if (!$scope.commissionPaymentDetails.attachments) {
                  $scope.commissionPaymentDetails.attachments = [];
                }
                $scope.commissionPaymentDetails.attachments[0] = response.data;
                self.$mdDialog.hide($scope.commissionPaymentDetails);
              })
              .catch((error) => {
                if (error) {
                  self.commonsAlertsService.somethingWentWrongError();
                  $scope.loading = false;
                }
              })
          }
        }


      }
    })
  }

  editPrice(price?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-consolidated-commission-price-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {

        $scope.price = angular.copy(price);
        $scope.comment = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onPriceChange = (price) => {
          $scope.price = price;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({price: $scope.price, comment: $scope.comment})

            }
          }
        }


      }
    })
  }


}

angular
  .module('bringoz.admin.commissions')
  .service('commissionsDialogService', CommissionsDialogService);
